export * from "./globalStyle"

export const em = (n: number) => `${n}em`
